<template>
    <transition name="fade">
        <div class="Praxisvortraege">
                
            <div class="vg-cross" @click="leaveGallery()"/>

            <!-- Video -->
            <div class="vg-video-container">

                <img v-show="!isModeratorAvailable" class="vg-video" :src="getWaitingThumbnail" alt="">

                <div v-show="isModeratorAvailable">
                    <video id="vg-video" class="vg-video" @click="playVideo(); sendModeratorCommands();" :src="videos[currentVideoIndex]" preload="metadata"/>
                
                    <div class="vg-paused" :style="{ background: paused ? 'rgba(0,0,0,0.5)' : 'none'}" v-if="paused" @click="playVideo(); sendModeratorCommands();">
                        <img class="vg-paused-icon" :src="'./media/pause.svg'" alt="">
                    </div>
                
                    <div class="vg-controls" v-show="userIsModerator()">
                        <div class="vg-controls-top">
                            <button class="vg-controls-button" @click="playVideo(); sendModeratorCommands();">
                                <img class="vg-controls-button-image" :src="paused ? './media/play.svg' : './media/pause.svg'" alt="">
                            </button>
                            <!-- <button class="vg-controls-button">
                                <img class="vg-controls-button-image" :src="paused ? './media/volume_up.svg' : './media/volume_up.svg'" alt=""> -->
                                <!-- <input value="0" step="0.001" type="range"> -->
                            <!-- </button> -->
                            <span class="vg-controls-time">{{videoCurentTime}}</span>
                        </div>
                        
                        <input value="0" id="vg-slider" class="vg-controls-slider" step="0.001" @input="changeTime(); sendModeratorCommands();" type="range">
                    </div>
                </div>
            </div>

            <!-- Video List -->
            <div class="vg-videolist-container" v-if="userIsModerator()">
                <div class="vg-videolist-video" v-for="(video,i) in videos" :key="video">
                    <video class="vg-videolist-videosrc" :src="video" @click="changeVideo(i); sendModeratorCommands();" :style="{ outline: i == currentVideoIndex ? '4px solid var(--primaryColor)' : 'none'}"/>
                    <p class="vg-videolist-title">{{videoTitles[i]}}</p>
                </div>
            </div>

        </div>  
    </transition>
</template>

<script>
import {mapGetters,mapState,mapMutations} from 'vuex';

export default {
    computed: {
        ...mapGetters(['logoURL','localUser','localUserID','moderatorMode','users']),
        ...mapState({session: (state) => state.session.openTokSession}), 
        videos(){
            var userLang = navigator.language || navigator.userLanguage; 
            if(userLang.includes("de"))
                return this.videosDeutsch 
            return this.videosEnglish
        },
        videoTitles(){
            var userLang = navigator.language || navigator.userLanguage; 
            if(userLang.includes("de"))
                return this.titleDeutsch 
            return this.titleEnglish
        },
        isModeratorAvailable(){
            let f = false;
            this.users.forEach(u => {
                if(u.getRole() === "moderator" || u.name == "Christian Nüsser")
                    f = true;        
            });
            return f;
        },
        getWaitingThumbnail(){
            var userLang = navigator.language || navigator.userLanguage; 
            if(userLang.includes("de"))
                return "./flux/Venjakob - TECH TOGETHER - Charts (Raumtänzer) - Englisch.jpg"
            return "./flux/Venjakob - TECH TOGETHER - Charts (Raumtänzer) - Deutsch.jpg"
        }
    },
    watch: {
        session: function(){
            this.session.on("signal:followModeratorVideoGallery", (event) => {
                let data = event.data.split(",");
                let userID = data[0];
                if (userID == this.localUserID)
                    return;

                let volume = data[1] != "undefined" ? parseFloat(data[1]) : undefined;
                let currentVideoID = data[2] != "undefined" ? parseInt(data[2]) : undefined;
                let paused = data[3] != "undefined" ? data[3] == "true" : undefined;
                let currentTime = data[4] != "undefined" ? parseFloat(data[4]) : undefined;

                let video =  document.getElementById("vg-video");
                paused ? video.pause() : video.play();
                video.currentTime = currentTime;
                this.currentVideoIndex = currentVideoID;      
            });
        },
    },
	methods: {
        ...mapMutations(['handleGotoSituationTransition']),
        leaveGallery(){
            window.open("https://sales.flux-cms.de/Venjakob-Messe/", "_self");
        },
        userIsModerator(){
            if(this.localUser)
                return this.localUser.getRole() === "moderator";
            return false;
        },
        muteAll(){
            this.users.forEach(u => {
                if(u.id != this.localUserID){
                    const signalData = {
                        type: "mute", 
                        data: u.id,
                    };
                    this.session.signal(signalData, function (error) {
                        if (error) 
                            console.log(['signal error (', error.code, '): ', error.message].join(''));
                        else 
                            console.log('mute signal sent');   
                    });
                }
            });
        },
        sendModeratorCommands(){
            if(this.session && this.userIsModerator()){
                let video = document.getElementById("vg-video");
                const signalData = {
                    type: "followModeratorVideoGallery", 
                    data: this.localUserID + "," + video.volume + "," + this.currentVideoIndex + "," + video.paused + "," + video.currentTime,
                };
                this.session.signal(signalData, function (error) {
                    if(error) 
                        console.log(['signal error (', error.code, '): ', error.message].join(''));
                    else 
                        console.log('followModeratorVideoGallery signal sent');   
                });
            }
        },
        playVideo(){
            if(!this.userIsModerator())
                return
            let video = document.getElementById("vg-video");
            if(video.paused)
                this.muteAll();
            video.paused ? video.play() : video.pause();
        },
        changeTime(){
            let video = document.getElementById("vg-video");
            video.currentTime = document.getElementById("vg-slider").value;
        },
        changeVideo(val){
            let video = document.getElementById("vg-video");
            this.currentVideoIndex = val;
            video.src = this.videos[this.currentVideoIndex];
        },
        formatTime(time) {
            var mins = Math.floor(time / 60);
            var secs = Math.floor(time - mins * 60);
            return mins + ":" + (secs < 10 ? "0" : "") + secs;
        },
    },
    mounted: function(){  
        let slider = document.getElementById("vg-slider");
        let video = document.getElementById("vg-video");
        video.onloadedmetadata = () =>{
            slider.max = video.duration;
            this.paused = video.paused;
        };
        video.ontimeupdate = () =>{
            this.videoCurentTime = this.formatTime(video.currentTime) + "/" + this.formatTime(slider.max);
            slider.value = video.currentTime;          
        };
        video.onplay = () =>{
            this.paused = false;
        }
        video.onpause = () =>{
            this.paused = true;
        }
    }, 
        data: function () {
        return {
            videoCurentTime: "0:00/0:00",
            paused: true,
            currentVideoIndex: 0,

            videosEnglish: [
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Betriebsführung - Englisch.mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Stender - Englisch.mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Runschke - Englisch (live) (H.264 1080p25 @ 10.000 kbit_s).mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Feldmann - Englisch.mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Maschinenvorführung VEN SPRAY PERFECT - Englisch.mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Maschinenvorführung VEN SPRAY ONE - Englisch.mp4",

            ],
            titleEnglish: [
                "Factory tour", "Talk Stender", "Talk Runschke", "Talk Feldmann", "Machine demonstration VEN SPRAY PERFECT", "Machine demonstration VEN SPRAY ONE"
            ],

            videosDeutsch: [
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Betriebsführung - Deutsch.mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Stender - Deutsch.mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Runschke - Deutsch.mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Feldmann - Deutsch.mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Maschinenvorführung VEN SPRAY PERFECT - Deutsch.mp4",
                "https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Maschinenvorführung VEN SPRAY ONE - Deutsch.mp4",
            ],
            titleDeutsch: [
                "Betriebsführung", "Vortrag Stender", "Vortrag Runschke", "Vortrag Feldmann", "Maschinenvorführung VEN SPRAY PERFECT", "Maschinenvorführung VEN SPRAY ONE"
            ],
        }
    }, 
}
</script>

<style scoped>
    .Praxisvortraege{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1;
        background: white;
    }
    .vg-video-container{
        position: relative;
        display: inline-block;
        justify-content: center;
        align-items: center;
        width: 70%;
    }
    .vg-videolist-container{
        width: 20%;
        height: 80%;
        margin-left: 40px;
        overflow-y: auto;
        overflow-x: hidden;
        display: inline-block;
    }
    .vg-videolist-video{
        margin: 5px;
        margin-bottom: 0;
        cursor: pointer;
    }
    .vg-videolist-videosrc:hover{
        outline: 4px solid #124147 !important;
    }
    .vg-videolist-title{
        margin: 0;
        font-size: 16px;
        margin-top: 5px;
        margin-bottom: 15px;
        text-align: center;
    }
    .vg-video{
        margin-top: 40px;
        width: 100%;
        max-height: 80vh;
        cursor: pointer;
    }
    .vg-paused{
        width: 100%;
        left: 0.5px;
        height: calc(100% - 40px);
        cursor: pointer;
        position: absolute;
        bottom: 0%;
    }
    .vg-paused-icon{
        position: absolute;
        left: calc(50% - 25px);
        bottom: calc(50% - 25px);
        width: 70px;
        height: 70px;
    }
    .vg-controls{
        z-index: 2;
        position: absolute;
        bottom: 1px;
        left: 0;
        opacity: 0;
        transition: .3s opacity ease-in-out;
        height: 70px;
        width: calc(100% + 1px);
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.788) 70%);
    }
    .vg-video:hover + .vg-controls{
        opacity: 1;
    }
    .vg-paused:hover + .vg-controls{
        opacity: 1;
    }
    .vg-controls:hover{
        opacity: 1;
    }
    .vg-controls-button{
        border: none;
        background: transparent;
        border-radius: 5px;
        transition: .2s background ease;
        margin: 2px;
        cursor: pointer;
    }
    .vg-controls-button:hover{
        background: rgba(255, 255, 255, 0.1);
    }
    .vg-controls-button-image{
        width: 30px;
        height: 30px;
        margin: 2px;
    }
    .vg-controls-time{
        color: white;
        font-size: 16px;
        margin-left: 15px;
    }
    .vg-controls-slider{
        width: 98%;
        cursor: pointer;
        margin-left: 1%;
        margin-right: 1%;
    }
    .vg-controls-top{
        display: flex;
        align-items: center;
    }
    .vg-cross {
        left: 40px;
        top: 40px;
        width: 60px;
        height: 60px;
        position: absolute;
        cursor: pointer;
    }
    .vg-cross:after {
        content: '';
        height: 30px;
        border-left: 4px solid red;
        position: absolute;
        transform: rotate(45deg);
        left: 28px;
    }
    .vg-cross:before {
        content: '';
        height: 30px;
        border-left: 4px solid red;
        position: absolute;
        transform: rotate(-45deg);
        left: 28px;
    }
</style>